import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Curtain = createSvgIcon(
  <path d="M4.5 2.25V0H2.25v2.25H0V4.5h2.25v11.25H0V18h2.375v6h7.69l-1.5-6h2.685v-2.25H9.674c1.631-1.362 2.985-3.063 4.032-4.75a22.788 22.788 0 0 0 2.047-4.184c.296-.816.517-1.607.64-2.316H24V2.25h-7.5V0h-2.25v2.25H10.5V0H8.25v2.25H4.5Zm0 2.25h9.6c-.1.447-.252.97-.463 1.55a20.539 20.539 0 0 1-1.843 3.763c-1.587 2.556-3.789 4.896-6.38 5.937H4.5V4.5ZM6.247 18l.937 3.75H4.625V18h1.622Z" />,
  'Curtain'
);

export { Curtain };